import React from 'react';
import PropTypes from 'prop-types';

import { usePrefs } from 'wsm-common-data';
import { DetailedIncentives, filterIncentiveIds } from 'wsm-incentive-display';

import vehiclePropType from '../../../propTypes/vehiclePropType';

const DetailedIncentivesContainer = ({
	accountInfo,
	vehicle,
	incentives,
	isSRPGridLayout = false
}) => {
	const prefs = usePrefs();

	const {
		incentiveDisplayGrouping,
		incentiveTitleCustom,
		incentiveTitleDisplay,
		showDealerConditionalIncentives,
		showDealerRegularIncentives,
		showOemConditionalIncentives,
		showOemNationalIncentives
	} = prefs;

	const {
		bestIncentiveIds = [],
		condition,
		images,
		incentiveIds = [],
		pricing = {},
		title
	} = vehicle;

	const incentiveIdList = incentiveIds || bestIncentiveIds || [];
	const filteredIncentives = filterIncentiveIds(incentives, incentiveIdList);

	return filteredIncentives.length ? (
		<DetailedIncentives
			incentives={filteredIncentives}
			accountInfo={accountInfo}
			incentiveTitleDisplay={incentiveTitleDisplay}
			incentiveTitleCustom={incentiveTitleCustom}
			incentiveDisplayGrouping={incentiveDisplayGrouping}
			isSRPGridLayout={isSRPGridLayout}
			showDealerRegularIncentives={showDealerRegularIncentives === 'true'}
			showDealerConditionalIncentives={
				showDealerConditionalIncentives === 'true'
			}
			showOemNationalIncentives={showOemNationalIncentives === 'true'}
			showOemConditionalIncentives={
				showOemConditionalIncentives === 'true'
			}
			vehicleData={{
				images,
				title,
				pricing,
				condition
			}}
		/>
	) : null;
};

DetailedIncentivesContainer.propTypes = {
	accountInfo: PropTypes.shape({}),
	incentives: PropTypes.shape({}),
	vehicle: vehiclePropType.isRequired,
	isSRPGridLayout: PropTypes.bool
};

export default DetailedIncentivesContainer;
